/**
 * Interface for the 'User' data
 */
export interface UserEntity {
  id: string | number; // Primary ID
}
